import { useEffect, useState } from "react";
import logo from "../assets/img/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
// import { auth } from "../firebase"; // Make sure this path is correct
import { auth, db } from "../firebase"; // তোমার config ফাইল থেকে
// import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // ✅ Added react-icons
import { doc, getDoc } from "firebase/firestore";
import { toast, ToastContainer } from "react-toastify"; // ✅ Added react-toastify
// import "/react-toastify/dist/ReactToastify.css"; // ✅ Import Toast styling


const Signin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false); // ✅ Added for password toggle
  const navigate = useNavigate();

  useEffect(() => {
    const yearSpan = document.getElementById("year");
    if (yearSpan) {
      yearSpan.textContent = new Date().getFullYear().toString();
    }
  }, []);

  const handleSignin = async (e) => {
    e.preventDefault();
    setError("");

    // try {
    //   await signInWithEmailAndPassword(auth, email, password);
    //   navigate("/dashboard"); // Redirect to dashboard on success
    // } catch (err) {
    //   setError("Invalid email or password.");
    // }

    try {

    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Check admin access

    const adminDocRef = doc(db, "admins", user.uid);
    const adminSnap = await getDoc(adminDocRef);

    // Admin record must exist

    if (!adminSnap.exists()) {
        await auth.signOut();
        toast.error("Access denied.");
        return;
    }
    const adminData = adminSnap.data();
    // Safety check
    if (adminData.uid !== user.uid) {
        await auth.signOut();
        toast.error("Invalid admin account.");
        return;
    }
    // Account enabled check
    if (adminData.enabled !== true) {
        await auth.signOut();
        toast.error("Admin account is disabled.");
        return;
    }
    // Store role for future RBAC usage
    localStorage.setItem("adminRole", adminData.role || "manager");
    console.log(`Admin login successful. Role: ${adminData.role || "manager"}`);
    navigate("/dashboard");
  } catch (error) {
    console.error("Login failed:", error);
    toast.error("Invalid email or password.");
}
  };

  return (
    <div
      style={{
        background: "linear-gradient(135deg, var(--bg-primary) 0%, var(--primary-purple) 100%)",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        margin: 0,
      }}
    >
      <div className="logo text-center mb-4">
        <img src={logo} alt="MReloadpay Logo" style={{ width: "100px" }} />
      </div>

      <div
        className="signin-card"
        style={{
          background: "rgba(18, 5, 45, 0.85)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          padding: "30px 20px",
          borderRadius: "15px",
          width: "100%",
          maxWidth: "400px",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5)",
          border: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "20px",
            color: "var(--accent-lime)",
            fontSize: "20px",
            fontWeight: "bold",
          }}
        >
          Sign in
        </h2>

        {error && <div className="alert alert-danger">{error}</div>}

        <form onSubmit={handleSignin}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label" style={{ color: 'var(--text-primary)' }}>
              Email
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="password" className="form-label" style={{ color: 'var(--text-primary)' }}>
              Password
            </label>
            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"} // ✅ password show/hide
                className="form-control"
                id="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "10px",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#555",
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>

          <div className="d-grid">
            <button type="submit" className="btn btn-primary">
              Sign in
            </button>
          </div>
        </form>

        {/* <p className="text-center py-2">
          <Link to="/forget-password" className="text-decoration-none">
            Forget Password?
          </Link>
        </p> */}
      </div>
 

      {/* Toast Container */}
      <ToastContainer />
    </div>
  );
};

export default Signin;
